module.exports = __webpack_public_path__ + "components/flag/static/square/ci-2040bb4fcb497e89fbd5b4b891eb5f9a.svg";